/**
 * ADD_PARAM モジュール
 * - 現在のURLクエリパラメータを `.js-add-param` のリンクに付与
 */
export const ADD_PARAM = {
  init() {
    const param = window.location.search
    if (!param) return

    const links = document.querySelectorAll('a.js-add-param')
    links.forEach(link => {
      const currentHref = link.getAttribute('href')
      if (!currentHref) return

      if (!currentHref.includes('?')) {
        // パラメータなし → そのまま追加
        link.setAttribute('href', currentHref + param)
      } else {
        // 既にパラメータあり → `?` を `&` に置換して追加
        link.setAttribute('href', currentHref + param.replace('?', '&'))
      }
    })
  },
}
